import { useState } from "react";
import "./App.css";


export default function App() {
const [task, setTask] = useState("");
const [tasks, setTasks] = useState([]);


const addTask = () => {
if (task.trim() === "") return;
setTasks([...tasks, task]);
setTask("");
};


const deleteTask = (index) => {
setTasks(tasks.filter((_, i) => i !== index));
};


return (
<div className="app-container">
<h1 className="title">To‑Do List</h1>


<div className="input-section">
<input
type="text"
value={task}
onChange={(e) => setTask(e.target.value)}
placeholder="Enter a task..."
className="task-input"
/>
<button onClick={addTask} className="add-btn">Add</button>
</div>


<ul className="task-list">
{tasks.map((item, index) => (
<li key={index} className="task-item">
<span>{item}</span>
<button className="delete-btn" onClick={() => deleteTask(index)}>
Delete
</button>
</li>
))}
</ul>
</div>
);
}